export default {
  all: 'Tudo',
  app_disabled: 'Estamos a atualizar o conteúdo. Estará disponível em breve.',
  autocomplete_placeholder: 'Introduza a sua morada ou código postal',
  back_to_list: 'Retornar à lista',
  catalogue_image: 'Imagem do catálogo',
  catalogue_loading: 'Estamos à procura do seu catálogo',
  catalogues: 'Catálogo',
  catalogues_in_area: 'Catálogos próximos',
  catalogues_loading: 'Carregando',
  catalogues_near_you: 'Catálogos à sua volta',
  catalogues_not_found: 'De momento não existem catálogos nas proximidades, tente introduzir outro endereço ou volte em breve para mais ofertas.',
  close_catalogues: 'Fechar',
  close_products: 'Fechar',
  close_stores: 'Fechar',
  closed: 'Fechado',
  characteristics: 'Características',
  days_of_week: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
  description_missing: 'Nenhuma descrição disponível',
  expires: 'Expira',
  expired: 'Expirado',
  find_me: 'Encontre-me',
  geolocation_error: 'Atenção: a localização não produziu resultados',
  geolocation_image: 'Geolocalização',
  geolocation_info: 'Para podermos mostrar-lhe os catálogos à sua volta, precisamos de saber a sua localização. Introduza a sua morada ou código postal',
  geolocation_loading: 'Estamos a configurar a sua localização',
  geolocation_missing: 'Actualize a sua localização para ver ofertas e lojas perto de si.',
  localize_yourself: 'Localize-se',
  more_info: 'Saiba mais',
  next: 'Seguinte',
  not_now: 'Agora não',
  of: 'De',
  open: 'Aberto',
  open_24_hours: 'Aberto 24 horas',
  or: 'ou',
  other_stores: 'As ofertas estão disponíveis aqui também',
  page: 'Página',
  previous: 'Anterior',
  price: 'Preço',
  products: 'Produtos',
  products_find: 'Buscar um produto',
  index: 'Índice',
  products_list: 'Lista de produtos',
  read_all: 'Ler tudo',
  sale: 'Desconto',
  search_placeholder: 'O que procura?',
  stores: 'Lojas',
  understand: 'Eu entendi',
  usergeolocation_label: 'Introduza a sua morada para encontrar as melhores ofertas nas lojas perto de si.',
  fullscreen: 'Ecrã inteiro',
  fullscreenExit: 'Reduzir ecrã',
  no_nearest_store_at: 'Nao há lojas por perto',
  nearest_store_at: 'Loja mais próxima em {distance}',
  nearby_stores: 'Lojas próximas',
  show_all_pages: 'Ver todas as páginas',
  show: 'Mostrar',
  directionVertical: 'Scroll vertical',
  directionHorizontal: 'Scroll horizontal',
  share: 'Partilhar',
  share_with_friends: 'Partilhe com os seus amigos',
  copy_link: 'Copiar link',
  sms: 'SMS',
  email: 'email',
  more_stores: 'mais lojas',
  stores_within: 'Lojas num raio de {maxDistance}',
  invalid_offers_disclaimer: 'As ofertas deste catálogo não são válidas nas lojas à sua volta, consulte outro catálogo ou localize-se em outra zona.',
  download_pdf: 'Descarregar PDF',
  available_options: 'Disponível em {numOptions} opções:',
};
